export default [
  {
    "id": "Africa/Abidjan",
    "description": "Africa/Abidjan"
  },
  {
    "id": "Africa/Accra",
    "description": "Africa/Accra"
  },
  {
    "id": "Africa/Addis_Ababa",
    "description": "Africa/Addis Ababa"
  },
  {
    "id": "Africa/Algiers",
    "description": "Africa/Algiers"
  },
  {
    "id": "Africa/Asmara",
    "description": "Africa/Asmara"
  },
  {
    "id": "Africa/Asmera",
    "description": "Africa/Asmera"
  },
  {
    "id": "Africa/Bamako",
    "description": "Africa/Bamako"
  },
  {
    "id": "Africa/Bangui",
    "description": "Africa/Bangui"
  },
  {
    "id": "Africa/Banjul",
    "description": "Africa/Banjul"
  },
  {
    "id": "Africa/Bissau",
    "description": "Africa/Bissau"
  },
  {
    "id": "Africa/Blantyre",
    "description": "Africa/Blantyre"
  },
  {
    "id": "Africa/Brazzaville",
    "description": "Africa/Brazzaville"
  },
  {
    "id": "Africa/Bujumbura",
    "description": "Africa/Bujumbura"
  },
  {
    "id": "Africa/Cairo",
    "description": "Africa/Cairo"
  },
  {
    "id": "Africa/Casablanca",
    "description": "Africa/Casablanca"
  },
  {
    "id": "Africa/Ceuta",
    "description": "Africa/Ceuta"
  },
  {
    "id": "Africa/Conakry",
    "description": "Africa/Conakry"
  },
  {
    "id": "Africa/Dakar",
    "description": "Africa/Dakar"
  },
  {
    "id": "Africa/Dar_es_Salaam",
    "description": "Africa/Dar es Salaam"
  },
  {
    "id": "Africa/Djibouti",
    "description": "Africa/Djibouti"
  },
  {
    "id": "Africa/Douala",
    "description": "Africa/Douala"
  },
  {
    "id": "Africa/El_Aaiun",
    "description": "Africa/El Aaiun"
  },
  {
    "id": "Africa/Freetown",
    "description": "Africa/Freetown"
  },
  {
    "id": "Africa/Gaborone",
    "description": "Africa/Gaborone"
  },
  {
    "id": "Africa/Harare",
    "description": "Africa/Harare"
  },
  {
    "id": "Africa/Johannesburg",
    "description": "Africa/Johannesburg"
  },
  {
    "id": "Africa/Juba",
    "description": "Africa/Juba"
  },
  {
    "id": "Africa/Kampala",
    "description": "Africa/Kampala"
  },
  {
    "id": "Africa/Khartoum",
    "description": "Africa/Khartoum"
  },
  {
    "id": "Africa/Kigali",
    "description": "Africa/Kigali"
  },
  {
    "id": "Africa/Kinshasa",
    "description": "Africa/Kinshasa"
  },
  {
    "id": "Africa/Lagos",
    "description": "Africa/Lagos"
  },
  {
    "id": "Africa/Libreville",
    "description": "Africa/Libreville"
  },
  {
    "id": "Africa/Lome",
    "description": "Africa/Lome"
  },
  {
    "id": "Africa/Luanda",
    "description": "Africa/Luanda"
  },
  {
    "id": "Africa/Lubumbashi",
    "description": "Africa/Lubumbashi"
  },
  {
    "id": "Africa/Lusaka",
    "description": "Africa/Lusaka"
  },
  {
    "id": "Africa/Malabo",
    "description": "Africa/Malabo"
  },
  {
    "id": "Africa/Maputo",
    "description": "Africa/Maputo"
  },
  {
    "id": "Africa/Maseru",
    "description": "Africa/Maseru"
  },
  {
    "id": "Africa/Mbabane",
    "description": "Africa/Mbabane"
  },
  {
    "id": "Africa/Mogadishu",
    "description": "Africa/Mogadishu"
  },
  {
    "id": "Africa/Monrovia",
    "description": "Africa/Monrovia"
  },
  {
    "id": "Africa/Nairobi",
    "description": "Africa/Nairobi"
  },
  {
    "id": "Africa/Ndjamena",
    "description": "Africa/Ndjamena"
  },
  {
    "id": "Africa/Niamey",
    "description": "Africa/Niamey"
  },
  {
    "id": "Africa/Nouakchott",
    "description": "Africa/Nouakchott"
  },
  {
    "id": "Africa/Ouagadougou",
    "description": "Africa/Ouagadougou"
  },
  {
    "id": "Africa/Porto-Novo",
    "description": "Africa/Porto-Novo"
  },
  {
    "id": "Africa/Sao_Tome",
    "description": "Africa/Sao Tome"
  },
  {
    "id": "Africa/Timbuktu",
    "description": "Africa/Timbuktu"
  },
  {
    "id": "Africa/Tripoli",
    "description": "Africa/Tripoli"
  },
  {
    "id": "Africa/Tunis",
    "description": "Africa/Tunis"
  },
  {
    "id": "Africa/Windhoek",
    "description": "Africa/Windhoek"
  },
  {
    "id": "America/Adak",
    "description": "America/Adak"
  },
  {
    "id": "America/Anchorage",
    "description": "America/Anchorage"
  },
  {
    "id": "America/Anguilla",
    "description": "America/Anguilla"
  },
  {
    "id": "America/Antigua",
    "description": "America/Antigua"
  },
  {
    "id": "America/Araguaina",
    "description": "America/Araguaina"
  },
  {
    "id": "America/Argentina/Buenos_Aires",
    "description": "America/Argentina/Buenos Aires"
  },
  {
    "id": "America/Argentina/Catamarca",
    "description": "America/Argentina/Catamarca"
  },
  {
    "id": "America/Argentina/ComodRivadavia",
    "description": "America/Argentina/ComodRivadavia"
  },
  {
    "id": "America/Argentina/Cordoba",
    "description": "America/Argentina/Cordoba"
  },
  {
    "id": "America/Argentina/Jujuy",
    "description": "America/Argentina/Jujuy"
  },
  {
    "id": "America/Argentina/La_Rioja",
    "description": "America/Argentina/La Rioja"
  },
  {
    "id": "America/Argentina/Mendoza",
    "description": "America/Argentina/Mendoza"
  },
  {
    "id": "America/Argentina/Rio_Gallegos",
    "description": "America/Argentina/Rio Gallegos"
  },
  {
    "id": "America/Argentina/Salta",
    "description": "America/Argentina/Salta"
  },
  {
    "id": "America/Argentina/San_Juan",
    "description": "America/Argentina/San Juan"
  },
  {
    "id": "America/Argentina/San_Luis",
    "description": "America/Argentina/San Luis"
  },
  {
    "id": "America/Argentina/Tucuman",
    "description": "America/Argentina/Tucuman"
  },
  {
    "id": "America/Argentina/Ushuaia",
    "description": "America/Argentina/Ushuaia"
  },
  {
    "id": "America/Aruba",
    "description": "America/Aruba"
  },
  {
    "id": "America/Asuncion",
    "description": "America/Asuncion"
  },
  {
    "id": "America/Atikokan",
    "description": "America/Atikokan"
  },
  {
    "id": "America/Atka",
    "description": "America/Atka"
  },
  {
    "id": "America/Bahia",
    "description": "America/Bahia"
  },
  {
    "id": "America/Bahia_Banderas",
    "description": "America/Bahia Banderas"
  },
  {
    "id": "America/Barbados",
    "description": "America/Barbados"
  },
  {
    "id": "America/Belem",
    "description": "America/Belem"
  },
  {
    "id": "America/Belize",
    "description": "America/Belize"
  },
  {
    "id": "America/Blanc-Sablon",
    "description": "America/Blanc-Sablon"
  },
  {
    "id": "America/Boa_Vista",
    "description": "America/Boa Vista"
  },
  {
    "id": "America/Bogota",
    "description": "America/Bogota"
  },
  {
    "id": "America/Boise",
    "description": "America/Boise"
  },
  {
    "id": "America/Buenos_Aires",
    "description": "America/Buenos Aires"
  },
  {
    "id": "America/Cambridge_Bay",
    "description": "America/Cambridge Bay"
  },
  {
    "id": "America/Campo_Grande",
    "description": "America/Campo Grande"
  },
  {
    "id": "America/Cancun",
    "description": "America/Cancun"
  },
  {
    "id": "America/Caracas",
    "description": "America/Caracas"
  },
  {
    "id": "America/Catamarca",
    "description": "America/Catamarca"
  },
  {
    "id": "America/Cayenne",
    "description": "America/Cayenne"
  },
  {
    "id": "America/Cayman",
    "description": "America/Cayman"
  },
  {
    "id": "America/Chicago",
    "description": "America/Chicago"
  },
  {
    "id": "America/Chihuahua",
    "description": "America/Chihuahua"
  },
  {
    "id": "America/Coral_Harbour",
    "description": "America/Coral Harbour"
  },
  {
    "id": "America/Cordoba",
    "description": "America/Cordoba"
  },
  {
    "id": "America/Costa_Rica",
    "description": "America/Costa Rica"
  },
  {
    "id": "America/Creston",
    "description": "America/Creston"
  },
  {
    "id": "America/Cuiaba",
    "description": "America/Cuiaba"
  },
  {
    "id": "America/Curacao",
    "description": "America/Curacao"
  },
  {
    "id": "America/Danmarkshavn",
    "description": "America/Danmarkshavn"
  },
  {
    "id": "America/Dawson",
    "description": "America/Dawson"
  },
  {
    "id": "America/Dawson_Creek",
    "description": "America/Dawson Creek"
  },
  {
    "id": "America/Denver",
    "description": "America/Denver"
  },
  {
    "id": "America/Detroit",
    "description": "America/Detroit"
  },
  {
    "id": "America/Dominica",
    "description": "America/Dominica"
  },
  {
    "id": "America/Edmonton",
    "description": "America/Edmonton"
  },
  {
    "id": "America/Eirunepe",
    "description": "America/Eirunepe"
  },
  {
    "id": "America/El_Salvador",
    "description": "America/El Salvador"
  },
  {
    "id": "America/Ensenada",
    "description": "America/Ensenada"
  },
  {
    "id": "America/Fort_Nelson",
    "description": "America/Fort Nelson"
  },
  {
    "id": "America/Fort_Wayne",
    "description": "America/Fort Wayne"
  },
  {
    "id": "America/Fortaleza",
    "description": "America/Fortaleza"
  },
  {
    "id": "America/Glace_Bay",
    "description": "America/Glace Bay"
  },
  {
    "id": "America/Godthab",
    "description": "America/Godthab"
  },
  {
    "id": "America/Goose_Bay",
    "description": "America/Goose Bay"
  },
  {
    "id": "America/Grand_Turk",
    "description": "America/Grand Turk"
  },
  {
    "id": "America/Grenada",
    "description": "America/Grenada"
  },
  {
    "id": "America/Guadeloupe",
    "description": "America/Guadeloupe"
  },
  {
    "id": "America/Guatemala",
    "description": "America/Guatemala"
  },
  {
    "id": "America/Guayaquil",
    "description": "America/Guayaquil"
  },
  {
    "id": "America/Guyana",
    "description": "America/Guyana"
  },
  {
    "id": "America/Halifax",
    "description": "America/Halifax"
  },
  {
    "id": "America/Havana",
    "description": "America/Havana"
  },
  {
    "id": "America/Hermosillo",
    "description": "America/Hermosillo"
  },
  {
    "id": "America/Indiana/Indianapolis",
    "description": "America/Indiana/Indianapolis"
  },
  {
    "id": "America/Indiana/Knox",
    "description": "America/Indiana/Knox"
  },
  {
    "id": "America/Indiana/Marengo",
    "description": "America/Indiana/Marengo"
  },
  {
    "id": "America/Indiana/Petersburg",
    "description": "America/Indiana/Petersburg"
  },
  {
    "id": "America/Indiana/Tell_City",
    "description": "America/Indiana/Tell City"
  },
  {
    "id": "America/Indiana/Vevay",
    "description": "America/Indiana/Vevay"
  },
  {
    "id": "America/Indiana/Vincennes",
    "description": "America/Indiana/Vincennes"
  },
  {
    "id": "America/Indiana/Winamac",
    "description": "America/Indiana/Winamac"
  },
  {
    "id": "America/Indianapolis",
    "description": "America/Indianapolis"
  },
  {
    "id": "America/Inuvik",
    "description": "America/Inuvik"
  },
  {
    "id": "America/Iqaluit",
    "description": "America/Iqaluit"
  },
  {
    "id": "America/Jamaica",
    "description": "America/Jamaica"
  },
  {
    "id": "America/Jujuy",
    "description": "America/Jujuy"
  },
  {
    "id": "America/Juneau",
    "description": "America/Juneau"
  },
  {
    "id": "America/Kentucky/Louisville",
    "description": "America/Kentucky/Louisville"
  },
  {
    "id": "America/Kentucky/Monticello",
    "description": "America/Kentucky/Monticello"
  },
  {
    "id": "America/Knox_IN",
    "description": "America/Knox IN"
  },
  {
    "id": "America/Kralendijk",
    "description": "America/Kralendijk"
  },
  {
    "id": "America/La_Paz",
    "description": "America/La Paz"
  },
  {
    "id": "America/Lima",
    "description": "America/Lima"
  },
  {
    "id": "America/Los_Angeles",
    "description": "America/Los Angeles"
  },
  {
    "id": "America/Louisville",
    "description": "America/Louisville"
  },
  {
    "id": "America/Lower_Princes",
    "description": "America/Lower Princes"
  },
  {
    "id": "America/Maceio",
    "description": "America/Maceio"
  },
  {
    "id": "America/Managua",
    "description": "America/Managua"
  },
  {
    "id": "America/Manaus",
    "description": "America/Manaus"
  },
  {
    "id": "America/Marigot",
    "description": "America/Marigot"
  },
  {
    "id": "America/Martinique",
    "description": "America/Martinique"
  },
  {
    "id": "America/Matamoros",
    "description": "America/Matamoros"
  },
  {
    "id": "America/Mazatlan",
    "description": "America/Mazatlan"
  },
  {
    "id": "America/Mendoza",
    "description": "America/Mendoza"
  },
  {
    "id": "America/Menominee",
    "description": "America/Menominee"
  },
  {
    "id": "America/Merida",
    "description": "America/Merida"
  },
  {
    "id": "America/Metlakatla",
    "description": "America/Metlakatla"
  },
  {
    "id": "America/Mexico_City",
    "description": "America/Mexico City"
  },
  {
    "id": "America/Miquelon",
    "description": "America/Miquelon"
  },
  {
    "id": "America/Moncton",
    "description": "America/Moncton"
  },
  {
    "id": "America/Monterrey",
    "description": "America/Monterrey"
  },
  {
    "id": "America/Montevideo",
    "description": "America/Montevideo"
  },
  {
    "id": "America/Montreal",
    "description": "America/Montreal"
  },
  {
    "id": "America/Montserrat",
    "description": "America/Montserrat"
  },
  {
    "id": "America/Nassau",
    "description": "America/Nassau"
  },
  {
    "id": "America/New_York",
    "description": "America/New York"
  },
  {
    "id": "America/Nipigon",
    "description": "America/Nipigon"
  },
  {
    "id": "America/Nome",
    "description": "America/Nome"
  },
  {
    "id": "America/Noronha",
    "description": "America/Noronha"
  },
  {
    "id": "America/North_Dakota/Beulah",
    "description": "America/North Dakota/Beulah"
  },
  {
    "id": "America/North_Dakota/Center",
    "description": "America/North Dakota/Center"
  },
  {
    "id": "America/North_Dakota/New_Salem",
    "description": "America/North Dakota/New Salem"
  },
  {
    "id": "America/Nuuk",
    "description": "America/Nuuk"
  },
  {
    "id": "America/Ojinaga",
    "description": "America/Ojinaga"
  },
  {
    "id": "America/Panama",
    "description": "America/Panama"
  },
  {
    "id": "America/Pangnirtung",
    "description": "America/Pangnirtung"
  },
  {
    "id": "America/Paramaribo",
    "description": "America/Paramaribo"
  },
  {
    "id": "America/Phoenix",
    "description": "America/Phoenix"
  },
  {
    "id": "America/Port-au-Prince",
    "description": "America/Port-au-Prince"
  },
  {
    "id": "America/Port_of_Spain",
    "description": "America/Port of Spain"
  },
  {
    "id": "America/Porto_Acre",
    "description": "America/Porto Acre"
  },
  {
    "id": "America/Porto_Velho",
    "description": "America/Porto Velho"
  },
  {
    "id": "America/Puerto_Rico",
    "description": "America/Puerto Rico"
  },
  {
    "id": "America/Punta_Arenas",
    "description": "America/Punta Arenas"
  },
  {
    "id": "America/Rainy_River",
    "description": "America/Rainy River"
  },
  {
    "id": "America/Rankin_Inlet",
    "description": "America/Rankin Inlet"
  },
  {
    "id": "America/Recife",
    "description": "America/Recife"
  },
  {
    "id": "America/Regina",
    "description": "America/Regina"
  },
  {
    "id": "America/Resolute",
    "description": "America/Resolute"
  },
  {
    "id": "America/Rio_Branco",
    "description": "America/Rio Branco"
  },
  {
    "id": "America/Rosario",
    "description": "America/Rosario"
  },
  {
    "id": "America/Santa_Isabel",
    "description": "America/Santa Isabel"
  },
  {
    "id": "America/Santarem",
    "description": "America/Santarem"
  },
  {
    "id": "America/Santiago",
    "description": "America/Santiago"
  },
  {
    "id": "America/Santo_Domingo",
    "description": "America/Santo Domingo"
  },
  {
    "id": "America/Sao_Paulo",
    "description": "America/Sao Paulo"
  },
  {
    "id": "America/Scoresbysund",
    "description": "America/Scoresbysund"
  },
  {
    "id": "America/Shiprock",
    "description": "America/Shiprock"
  },
  {
    "id": "America/Sitka",
    "description": "America/Sitka"
  },
  {
    "id": "America/St_Barthelemy",
    "description": "America/St Barthelemy"
  },
  {
    "id": "America/St_Johns",
    "description": "America/St Johns"
  },
  {
    "id": "America/St_Kitts",
    "description": "America/St Kitts"
  },
  {
    "id": "America/St_Lucia",
    "description": "America/St Lucia"
  },
  {
    "id": "America/St_Thomas",
    "description": "America/St Thomas"
  },
  {
    "id": "America/St_Vincent",
    "description": "America/St Vincent"
  },
  {
    "id": "America/Swift_Current",
    "description": "America/Swift Current"
  },
  {
    "id": "America/Tegucigalpa",
    "description": "America/Tegucigalpa"
  },
  {
    "id": "America/Thule",
    "description": "America/Thule"
  },
  {
    "id": "America/Thunder_Bay",
    "description": "America/Thunder Bay"
  },
  {
    "id": "America/Tijuana",
    "description": "America/Tijuana"
  },
  {
    "id": "America/Toronto",
    "description": "America/Toronto"
  },
  {
    "id": "America/Tortola",
    "description": "America/Tortola"
  },
  {
    "id": "America/Vancouver",
    "description": "America/Vancouver"
  },
  {
    "id": "America/Virgin",
    "description": "America/Virgin"
  },
  {
    "id": "America/Whitehorse",
    "description": "America/Whitehorse"
  },
  {
    "id": "America/Winnipeg",
    "description": "America/Winnipeg"
  },
  {
    "id": "America/Yakutat",
    "description": "America/Yakutat"
  },
  {
    "id": "America/Yellowknife",
    "description": "America/Yellowknife"
  },
  {
    "id": "Antarctica/Casey",
    "description": "Antarctica/Casey"
  },
  {
    "id": "Antarctica/Davis",
    "description": "Antarctica/Davis"
  },
  {
    "id": "Antarctica/DumontDUrville",
    "description": "Antarctica/DumontDUrville"
  },
  {
    "id": "Antarctica/Macquarie",
    "description": "Antarctica/Macquarie"
  },
  {
    "id": "Antarctica/Mawson",
    "description": "Antarctica/Mawson"
  },
  {
    "id": "Antarctica/McMurdo",
    "description": "Antarctica/McMurdo"
  },
  {
    "id": "Antarctica/Palmer",
    "description": "Antarctica/Palmer"
  },
  {
    "id": "Antarctica/Rothera",
    "description": "Antarctica/Rothera"
  },
  {
    "id": "Antarctica/South_Pole",
    "description": "Antarctica/South Pole"
  },
  {
    "id": "Antarctica/Syowa",
    "description": "Antarctica/Syowa"
  },
  {
    "id": "Antarctica/Troll",
    "description": "Antarctica/Troll"
  },
  {
    "id": "Antarctica/Vostok",
    "description": "Antarctica/Vostok"
  },
  {
    "id": "Arctic/Longyearbyen",
    "description": "Arctic/Longyearbyen"
  },
  {
    "id": "Asia/Aden",
    "description": "Asia/Aden"
  },
  {
    "id": "Asia/Almaty",
    "description": "Asia/Almaty"
  },
  {
    "id": "Asia/Amman",
    "description": "Asia/Amman"
  },
  {
    "id": "Asia/Anadyr",
    "description": "Asia/Anadyr"
  },
  {
    "id": "Asia/Aqtau",
    "description": "Asia/Aqtau"
  },
  {
    "id": "Asia/Aqtobe",
    "description": "Asia/Aqtobe"
  },
  {
    "id": "Asia/Ashgabat",
    "description": "Asia/Ashgabat"
  },
  {
    "id": "Asia/Ashkhabad",
    "description": "Asia/Ashkhabad"
  },
  {
    "id": "Asia/Atyrau",
    "description": "Asia/Atyrau"
  },
  {
    "id": "Asia/Baghdad",
    "description": "Asia/Baghdad"
  },
  {
    "id": "Asia/Bahrain",
    "description": "Asia/Bahrain"
  },
  {
    "id": "Asia/Baku",
    "description": "Asia/Baku"
  },
  {
    "id": "Asia/Bangkok",
    "description": "Asia/Bangkok"
  },
  {
    "id": "Asia/Barnaul",
    "description": "Asia/Barnaul"
  },
  {
    "id": "Asia/Beirut",
    "description": "Asia/Beirut"
  },
  {
    "id": "Asia/Bishkek",
    "description": "Asia/Bishkek"
  },
  {
    "id": "Asia/Brunei",
    "description": "Asia/Brunei"
  },
  {
    "id": "Asia/Calcutta",
    "description": "Asia/Calcutta"
  },
  {
    "id": "Asia/Chita",
    "description": "Asia/Chita"
  },
  {
    "id": "Asia/Choibalsan",
    "description": "Asia/Choibalsan"
  },
  {
    "id": "Asia/Chongqing",
    "description": "Asia/Chongqing"
  },
  {
    "id": "Asia/Chungking",
    "description": "Asia/Chungking"
  },
  {
    "id": "Asia/Colombo",
    "description": "Asia/Colombo"
  },
  {
    "id": "Asia/Dacca",
    "description": "Asia/Dacca"
  },
  {
    "id": "Asia/Damascus",
    "description": "Asia/Damascus"
  },
  {
    "id": "Asia/Dhaka",
    "description": "Asia/Dhaka"
  },
  {
    "id": "Asia/Dili",
    "description": "Asia/Dili"
  },
  {
    "id": "Asia/Dubai",
    "description": "Asia/Dubai"
  },
  {
    "id": "Asia/Dushanbe",
    "description": "Asia/Dushanbe"
  },
  {
    "id": "Asia/Famagusta",
    "description": "Asia/Famagusta"
  },
  {
    "id": "Asia/Gaza",
    "description": "Asia/Gaza"
  },
  {
    "id": "Asia/Harbin",
    "description": "Asia/Harbin"
  },
  {
    "id": "Asia/Hebron",
    "description": "Asia/Hebron"
  },
  {
    "id": "Asia/Ho_Chi_Minh",
    "description": "Asia/Ho Chi Minh"
  },
  {
    "id": "Asia/Hong_Kong",
    "description": "Asia/Hong Kong"
  },
  {
    "id": "Asia/Hovd",
    "description": "Asia/Hovd"
  },
  {
    "id": "Asia/Irkutsk",
    "description": "Asia/Irkutsk"
  },
  {
    "id": "Asia/Istanbul",
    "description": "Asia/Istanbul"
  },
  {
    "id": "Asia/Jakarta",
    "description": "Asia/Jakarta"
  },
  {
    "id": "Asia/Jayapura",
    "description": "Asia/Jayapura"
  },
  {
    "id": "Asia/Jerusalem",
    "description": "Asia/Jerusalem"
  },
  {
    "id": "Asia/Kabul",
    "description": "Asia/Kabul"
  },
  {
    "id": "Asia/Kamchatka",
    "description": "Asia/Kamchatka"
  },
  {
    "id": "Asia/Karachi",
    "description": "Asia/Karachi"
  },
  {
    "id": "Asia/Kashgar",
    "description": "Asia/Kashgar"
  },
  {
    "id": "Asia/Kathmandu",
    "description": "Asia/Kathmandu"
  },
  {
    "id": "Asia/Katmandu",
    "description": "Asia/Katmandu"
  },
  {
    "id": "Asia/Khandyga",
    "description": "Asia/Khandyga"
  },
  {
    "id": "Asia/Kolkata",
    "description": "Asia/Kolkata"
  },
  {
    "id": "Asia/Krasnoyarsk",
    "description": "Asia/Krasnoyarsk"
  },
  {
    "id": "Asia/Kuala_Lumpur",
    "description": "Asia/Kuala Lumpur"
  },
  {
    "id": "Asia/Kuching",
    "description": "Asia/Kuching"
  },
  {
    "id": "Asia/Kuwait",
    "description": "Asia/Kuwait"
  },
  {
    "id": "Asia/Macao",
    "description": "Asia/Macao"
  },
  {
    "id": "Asia/Macau",
    "description": "Asia/Macau"
  },
  {
    "id": "Asia/Magadan",
    "description": "Asia/Magadan"
  },
  {
    "id": "Asia/Makassar",
    "description": "Asia/Makassar"
  },
  {
    "id": "Asia/Manila",
    "description": "Asia/Manila"
  },
  {
    "id": "Asia/Muscat",
    "description": "Asia/Muscat"
  },
  {
    "id": "Asia/Nicosia",
    "description": "Asia/Nicosia"
  },
  {
    "id": "Asia/Novokuznetsk",
    "description": "Asia/Novokuznetsk"
  },
  {
    "id": "Asia/Novosibirsk",
    "description": "Asia/Novosibirsk"
  },
  {
    "id": "Asia/Omsk",
    "description": "Asia/Omsk"
  },
  {
    "id": "Asia/Oral",
    "description": "Asia/Oral"
  },
  {
    "id": "Asia/Phnom_Penh",
    "description": "Asia/Phnom Penh"
  },
  {
    "id": "Asia/Pontianak",
    "description": "Asia/Pontianak"
  },
  {
    "id": "Asia/Pyongyang",
    "description": "Asia/Pyongyang"
  },
  {
    "id": "Asia/Qatar",
    "description": "Asia/Qatar"
  },
  {
    "id": "Asia/Qostanay",
    "description": "Asia/Qostanay"
  },
  {
    "id": "Asia/Qyzylorda",
    "description": "Asia/Qyzylorda"
  },
  {
    "id": "Asia/Rangoon",
    "description": "Asia/Rangoon"
  },
  {
    "id": "Asia/Riyadh",
    "description": "Asia/Riyadh"
  },
  {
    "id": "Asia/Saigon",
    "description": "Asia/Saigon"
  },
  {
    "id": "Asia/Sakhalin",
    "description": "Asia/Sakhalin"
  },
  {
    "id": "Asia/Samarkand",
    "description": "Asia/Samarkand"
  },
  {
    "id": "Asia/Seoul",
    "description": "Asia/Seoul"
  },
  {
    "id": "Asia/Shanghai",
    "description": "Asia/Shanghai"
  },
  {
    "id": "Asia/Singapore",
    "description": "Asia/Singapore"
  },
  {
    "id": "Asia/Srednekolymsk",
    "description": "Asia/Srednekolymsk"
  },
  {
    "id": "Asia/Taipei",
    "description": "Asia/Taipei"
  },
  {
    "id": "Asia/Tashkent",
    "description": "Asia/Tashkent"
  },
  {
    "id": "Asia/Tbilisi",
    "description": "Asia/Tbilisi"
  },
  {
    "id": "Asia/Tehran",
    "description": "Asia/Tehran"
  },
  {
    "id": "Asia/Tel_Aviv",
    "description": "Asia/Tel Aviv"
  },
  {
    "id": "Asia/Thimbu",
    "description": "Asia/Thimbu"
  },
  {
    "id": "Asia/Thimphu",
    "description": "Asia/Thimphu"
  },
  {
    "id": "Asia/Tokyo",
    "description": "Asia/Tokyo"
  },
  {
    "id": "Asia/Tomsk",
    "description": "Asia/Tomsk"
  },
  {
    "id": "Asia/Ujung_Pandang",
    "description": "Asia/Ujung Pandang"
  },
  {
    "id": "Asia/Ulaanbaatar",
    "description": "Asia/Ulaanbaatar"
  },
  {
    "id": "Asia/Ulan_Bator",
    "description": "Asia/Ulan Bator"
  },
  {
    "id": "Asia/Urumqi",
    "description": "Asia/Urumqi"
  },
  {
    "id": "Asia/Ust-Nera",
    "description": "Asia/Ust-Nera"
  },
  {
    "id": "Asia/Vientiane",
    "description": "Asia/Vientiane"
  },
  {
    "id": "Asia/Vladivostok",
    "description": "Asia/Vladivostok"
  },
  {
    "id": "Asia/Yakutsk",
    "description": "Asia/Yakutsk"
  },
  {
    "id": "Asia/Yangon",
    "description": "Asia/Yangon"
  },
  {
    "id": "Asia/Yekaterinburg",
    "description": "Asia/Yekaterinburg"
  },
  {
    "id": "Asia/Yerevan",
    "description": "Asia/Yerevan"
  },
  {
    "id": "Atlantic/Azores",
    "description": "Atlantic/Azores"
  },
  {
    "id": "Atlantic/Bermuda",
    "description": "Atlantic/Bermuda"
  },
  {
    "id": "Atlantic/Canary",
    "description": "Atlantic/Canary"
  },
  {
    "id": "Atlantic/Cape_Verde",
    "description": "Atlantic/Cape Verde"
  },
  {
    "id": "Atlantic/Faeroe",
    "description": "Atlantic/Faeroe"
  },
  {
    "id": "Atlantic/Faroe",
    "description": "Atlantic/Faroe"
  },
  {
    "id": "Atlantic/Jan_Mayen",
    "description": "Atlantic/Jan Mayen"
  },
  {
    "id": "Atlantic/Madeira",
    "description": "Atlantic/Madeira"
  },
  {
    "id": "Atlantic/Reykjavik",
    "description": "Atlantic/Reykjavik"
  },
  {
    "id": "Atlantic/South_Georgia",
    "description": "Atlantic/South Georgia"
  },
  {
    "id": "Atlantic/St_Helena",
    "description": "Atlantic/St Helena"
  },
  {
    "id": "Atlantic/Stanley",
    "description": "Atlantic/Stanley"
  },
  {
    "id": "Australia/ACT",
    "description": "Australia/ACT"
  },
  {
    "id": "Australia/Adelaide",
    "description": "Australia/Adelaide"
  },
  {
    "id": "Australia/Brisbane",
    "description": "Australia/Brisbane"
  },
  {
    "id": "Australia/Broken_Hill",
    "description": "Australia/Broken Hill"
  },
  {
    "id": "Australia/Canberra",
    "description": "Australia/Canberra"
  },
  {
    "id": "Australia/Currie",
    "description": "Australia/Currie"
  },
  {
    "id": "Australia/Darwin",
    "description": "Australia/Darwin"
  },
  {
    "id": "Australia/Eucla",
    "description": "Australia/Eucla"
  },
  {
    "id": "Australia/Hobart",
    "description": "Australia/Hobart"
  },
  {
    "id": "Australia/LHI",
    "description": "Australia/LHI"
  },
  {
    "id": "Australia/Lindeman",
    "description": "Australia/Lindeman"
  },
  {
    "id": "Australia/Lord_Howe",
    "description": "Australia/Lord Howe"
  },
  {
    "id": "Australia/Melbourne",
    "description": "Australia/Melbourne"
  },
  {
    "id": "Australia/NSW",
    "description": "Australia/NSW"
  },
  {
    "id": "Australia/North",
    "description": "Australia/North"
  },
  {
    "id": "Australia/Perth",
    "description": "Australia/Perth"
  },
  {
    "id": "Australia/Queensland",
    "description": "Australia/Queensland"
  },
  {
    "id": "Australia/South",
    "description": "Australia/South"
  },
  {
    "id": "Australia/Sydney",
    "description": "Australia/Sydney"
  },
  {
    "id": "Australia/Tasmania",
    "description": "Australia/Tasmania"
  },
  {
    "id": "Australia/Victoria",
    "description": "Australia/Victoria"
  },
  {
    "id": "Australia/West",
    "description": "Australia/West"
  },
  {
    "id": "Australia/Yancowinna",
    "description": "Australia/Yancowinna"
  },
  {
    "id": "Brazil/Acre",
    "description": "Brazil/Acre"
  },
  {
    "id": "Brazil/DeNoronha",
    "description": "Brazil/DeNoronha"
  },
  {
    "id": "Brazil/East",
    "description": "Brazil/East"
  },
  {
    "id": "Brazil/West",
    "description": "Brazil/West"
  },
  {
    "id": "CET",
    "description": "CET"
  },
  {
    "id": "CST6CDT",
    "description": "CST6CDT"
  },
  {
    "id": "Canada/Atlantic",
    "description": "Canada/Atlantic"
  },
  {
    "id": "Canada/Central",
    "description": "Canada/Central"
  },
  {
    "id": "Canada/Eastern",
    "description": "Canada/Eastern"
  },
  {
    "id": "Canada/Mountain",
    "description": "Canada/Mountain"
  },
  {
    "id": "Canada/Newfoundland",
    "description": "Canada/Newfoundland"
  },
  {
    "id": "Canada/Pacific",
    "description": "Canada/Pacific"
  },
  {
    "id": "Canada/Saskatchewan",
    "description": "Canada/Saskatchewan"
  },
  {
    "id": "Canada/Yukon",
    "description": "Canada/Yukon"
  },
  {
    "id": "Chile/Continental",
    "description": "Chile/Continental"
  },
  {
    "id": "Chile/EasterIsland",
    "description": "Chile/EasterIsland"
  },
  {
    "id": "Cuba",
    "description": "Cuba"
  },
  {
    "id": "EET",
    "description": "EET"
  },
  {
    "id": "EST",
    "description": "EST"
  },
  {
    "id": "EST5EDT",
    "description": "EST5EDT"
  },
  {
    "id": "Egypt",
    "description": "Egypt"
  },
  {
    "id": "Eire",
    "description": "Eire"
  },
  {
    "id": "Etc/GMT",
    "description": "Etc/GMT"
  },
  {
    "id": "Etc/GMT+0",
    "description": "Etc/GMT+0"
  },
  {
    "id": "Etc/GMT+1",
    "description": "Etc/GMT+1"
  },
  {
    "id": "Etc/GMT+10",
    "description": "Etc/GMT+10"
  },
  {
    "id": "Etc/GMT+11",
    "description": "Etc/GMT+11"
  },
  {
    "id": "Etc/GMT+12",
    "description": "Etc/GMT+12"
  },
  {
    "id": "Etc/GMT+2",
    "description": "Etc/GMT+2"
  },
  {
    "id": "Etc/GMT+3",
    "description": "Etc/GMT+3"
  },
  {
    "id": "Etc/GMT+4",
    "description": "Etc/GMT+4"
  },
  {
    "id": "Etc/GMT+5",
    "description": "Etc/GMT+5"
  },
  {
    "id": "Etc/GMT+6",
    "description": "Etc/GMT+6"
  },
  {
    "id": "Etc/GMT+7",
    "description": "Etc/GMT+7"
  },
  {
    "id": "Etc/GMT+8",
    "description": "Etc/GMT+8"
  },
  {
    "id": "Etc/GMT+9",
    "description": "Etc/GMT+9"
  },
  {
    "id": "Etc/GMT-0",
    "description": "Etc/GMT-0"
  },
  {
    "id": "Etc/GMT-1",
    "description": "Etc/GMT-1"
  },
  {
    "id": "Etc/GMT-10",
    "description": "Etc/GMT-10"
  },
  {
    "id": "Etc/GMT-11",
    "description": "Etc/GMT-11"
  },
  {
    "id": "Etc/GMT-12",
    "description": "Etc/GMT-12"
  },
  {
    "id": "Etc/GMT-13",
    "description": "Etc/GMT-13"
  },
  {
    "id": "Etc/GMT-14",
    "description": "Etc/GMT-14"
  },
  {
    "id": "Etc/GMT-2",
    "description": "Etc/GMT-2"
  },
  {
    "id": "Etc/GMT-3",
    "description": "Etc/GMT-3"
  },
  {
    "id": "Etc/GMT-4",
    "description": "Etc/GMT-4"
  },
  {
    "id": "Etc/GMT-5",
    "description": "Etc/GMT-5"
  },
  {
    "id": "Etc/GMT-6",
    "description": "Etc/GMT-6"
  },
  {
    "id": "Etc/GMT-7",
    "description": "Etc/GMT-7"
  },
  {
    "id": "Etc/GMT-8",
    "description": "Etc/GMT-8"
  },
  {
    "id": "Etc/GMT-9",
    "description": "Etc/GMT-9"
  },
  {
    "id": "Etc/GMT0",
    "description": "Etc/GMT0"
  },
  {
    "id": "Etc/Greenwich",
    "description": "Etc/Greenwich"
  },
  {
    "id": "Etc/UCT",
    "description": "Etc/UCT"
  },
  {
    "id": "Etc/UTC",
    "description": "Etc/UTC"
  },
  {
    "id": "Etc/Universal",
    "description": "Etc/Universal"
  },
  {
    "id": "Etc/Zulu",
    "description": "Etc/Zulu"
  },
  {
    "id": "Europe/Amsterdam",
    "description": "Europe/Amsterdam"
  },
  {
    "id": "Europe/Andorra",
    "description": "Europe/Andorra"
  },
  {
    "id": "Europe/Astrakhan",
    "description": "Europe/Astrakhan"
  },
  {
    "id": "Europe/Athens",
    "description": "Europe/Athens"
  },
  {
    "id": "Europe/Belfast",
    "description": "Europe/Belfast"
  },
  {
    "id": "Europe/Belgrade",
    "description": "Europe/Belgrade"
  },
  {
    "id": "Europe/Berlin",
    "description": "Europe/Berlin"
  },
  {
    "id": "Europe/Bratislava",
    "description": "Europe/Bratislava"
  },
  {
    "id": "Europe/Brussels",
    "description": "Europe/Brussels"
  },
  {
    "id": "Europe/Bucharest",
    "description": "Europe/Bucharest"
  },
  {
    "id": "Europe/Budapest",
    "description": "Europe/Budapest"
  },
  {
    "id": "Europe/Busingen",
    "description": "Europe/Busingen"
  },
  {
    "id": "Europe/Chisinau",
    "description": "Europe/Chisinau"
  },
  {
    "id": "Europe/Copenhagen",
    "description": "Europe/Copenhagen"
  },
  {
    "id": "Europe/Dublin",
    "description": "Europe/Dublin"
  },
  {
    "id": "Europe/Gibraltar",
    "description": "Europe/Gibraltar"
  },
  {
    "id": "Europe/Guernsey",
    "description": "Europe/Guernsey"
  },
  {
    "id": "Europe/Helsinki",
    "description": "Europe/Helsinki"
  },
  {
    "id": "Europe/Isle_of_Man",
    "description": "Europe/Isle of Man"
  },
  {
    "id": "Europe/Istanbul",
    "description": "Europe/Istanbul"
  },
  {
    "id": "Europe/Jersey",
    "description": "Europe/Jersey"
  },
  {
    "id": "Europe/Kaliningrad",
    "description": "Europe/Kaliningrad"
  },
  {
    "id": "Europe/Kiev",
    "description": "Europe/Kiev"
  },
  {
    "id": "Europe/Kirov",
    "description": "Europe/Kirov"
  },
  {
    "id": "Europe/Lisbon",
    "description": "Europe/Lisbon"
  },
  {
    "id": "Europe/Ljubljana",
    "description": "Europe/Ljubljana"
  },
  {
    "id": "Europe/London",
    "description": "Europe/London"
  },
  {
    "id": "Europe/Luxembourg",
    "description": "Europe/Luxembourg"
  },
  {
    "id": "Europe/Madrid",
    "description": "Europe/Madrid"
  },
  {
    "id": "Europe/Malta",
    "description": "Europe/Malta"
  },
  {
    "id": "Europe/Mariehamn",
    "description": "Europe/Mariehamn"
  },
  {
    "id": "Europe/Minsk",
    "description": "Europe/Minsk"
  },
  {
    "id": "Europe/Monaco",
    "description": "Europe/Monaco"
  },
  {
    "id": "Europe/Moscow",
    "description": "Europe/Moscow"
  },
  {
    "id": "Europe/Nicosia",
    "description": "Europe/Nicosia"
  },
  {
    "id": "Europe/Oslo",
    "description": "Europe/Oslo"
  },
  {
    "id": "Europe/Paris",
    "description": "Europe/Paris"
  },
  {
    "id": "Europe/Podgorica",
    "description": "Europe/Podgorica"
  },
  {
    "id": "Europe/Prague",
    "description": "Europe/Prague"
  },
  {
    "id": "Europe/Riga",
    "description": "Europe/Riga"
  },
  {
    "id": "Europe/Rome",
    "description": "Europe/Rome"
  },
  {
    "id": "Europe/Samara",
    "description": "Europe/Samara"
  },
  {
    "id": "Europe/San_Marino",
    "description": "Europe/San Marino"
  },
  {
    "id": "Europe/Sarajevo",
    "description": "Europe/Sarajevo"
  },
  {
    "id": "Europe/Saratov",
    "description": "Europe/Saratov"
  },
  {
    "id": "Europe/Simferopol",
    "description": "Europe/Simferopol"
  },
  {
    "id": "Europe/Skopje",
    "description": "Europe/Skopje"
  },
  {
    "id": "Europe/Sofia",
    "description": "Europe/Sofia"
  },
  {
    "id": "Europe/Stockholm",
    "description": "Europe/Stockholm"
  },
  {
    "id": "Europe/Tallinn",
    "description": "Europe/Tallinn"
  },
  {
    "id": "Europe/Tirane",
    "description": "Europe/Tirane"
  },
  {
    "id": "Europe/Tiraspol",
    "description": "Europe/Tiraspol"
  },
  {
    "id": "Europe/Ulyanovsk",
    "description": "Europe/Ulyanovsk"
  },
  {
    "id": "Europe/Uzhgorod",
    "description": "Europe/Uzhgorod"
  },
  {
    "id": "Europe/Vaduz",
    "description": "Europe/Vaduz"
  },
  {
    "id": "Europe/Vatican",
    "description": "Europe/Vatican"
  },
  {
    "id": "Europe/Vienna",
    "description": "Europe/Vienna"
  },
  {
    "id": "Europe/Vilnius",
    "description": "Europe/Vilnius"
  },
  {
    "id": "Europe/Volgograd",
    "description": "Europe/Volgograd"
  },
  {
    "id": "Europe/Warsaw",
    "description": "Europe/Warsaw"
  },
  {
    "id": "Europe/Zagreb",
    "description": "Europe/Zagreb"
  },
  {
    "id": "Europe/Zaporozhye",
    "description": "Europe/Zaporozhye"
  },
  {
    "id": "Europe/Zurich",
    "description": "Europe/Zurich"
  },
  {
    "id": "GB",
    "description": "GB"
  },
  {
    "id": "GB-Eire",
    "description": "GB-Eire"
  },
  {
    "id": "GMT",
    "description": "GMT"
  },
  {
    "id": "GMT+0",
    "description": "GMT+0"
  },
  {
    "id": "GMT-0",
    "description": "GMT-0"
  },
  {
    "id": "GMT0",
    "description": "GMT0"
  },
  {
    "id": "Greenwich",
    "description": "Greenwich"
  },
  {
    "id": "HST",
    "description": "HST"
  },
  {
    "id": "Hongkong",
    "description": "Hongkong"
  },
  {
    "id": "Iceland",
    "description": "Iceland"
  },
  {
    "id": "Indian/Antananarivo",
    "description": "Indian/Antananarivo"
  },
  {
    "id": "Indian/Chagos",
    "description": "Indian/Chagos"
  },
  {
    "id": "Indian/Christmas",
    "description": "Indian/Christmas"
  },
  {
    "id": "Indian/Cocos",
    "description": "Indian/Cocos"
  },
  {
    "id": "Indian/Comoro",
    "description": "Indian/Comoro"
  },
  {
    "id": "Indian/Kerguelen",
    "description": "Indian/Kerguelen"
  },
  {
    "id": "Indian/Mahe",
    "description": "Indian/Mahe"
  },
  {
    "id": "Indian/Maldives",
    "description": "Indian/Maldives"
  },
  {
    "id": "Indian/Mauritius",
    "description": "Indian/Mauritius"
  },
  {
    "id": "Indian/Mayotte",
    "description": "Indian/Mayotte"
  },
  {
    "id": "Indian/Reunion",
    "description": "Indian/Reunion"
  },
  {
    "id": "Iran",
    "description": "Iran"
  },
  {
    "id": "Israel",
    "description": "Israel"
  },
  {
    "id": "Jamaica",
    "description": "Jamaica"
  },
  {
    "id": "Japan",
    "description": "Japan"
  },
  {
    "id": "Kwajalein",
    "description": "Kwajalein"
  },
  {
    "id": "Libya",
    "description": "Libya"
  },
  {
    "id": "MET",
    "description": "MET"
  },
  {
    "id": "MST",
    "description": "MST"
  },
  {
    "id": "MST7MDT",
    "description": "MST7MDT"
  },
  {
    "id": "Mexico/BajaNorte",
    "description": "Mexico/BajaNorte"
  },
  {
    "id": "Mexico/BajaSur",
    "description": "Mexico/BajaSur"
  },
  {
    "id": "Mexico/General",
    "description": "Mexico/General"
  },
  {
    "id": "NZ",
    "description": "NZ"
  },
  {
    "id": "NZ-CHAT",
    "description": "NZ-CHAT"
  },
  {
    "id": "Navajo",
    "description": "Navajo"
  },
  {
    "id": "PRC",
    "description": "PRC"
  },
  {
    "id": "PST8PDT",
    "description": "PST8PDT"
  },
  {
    "id": "Pacific/Apia",
    "description": "Pacific/Apia"
  },
  {
    "id": "Pacific/Auckland",
    "description": "Pacific/Auckland"
  },
  {
    "id": "Pacific/Bougainville",
    "description": "Pacific/Bougainville"
  },
  {
    "id": "Pacific/Chatham",
    "description": "Pacific/Chatham"
  },
  {
    "id": "Pacific/Chuuk",
    "description": "Pacific/Chuuk"
  },
  {
    "id": "Pacific/Easter",
    "description": "Pacific/Easter"
  },
  {
    "id": "Pacific/Efate",
    "description": "Pacific/Efate"
  },
  {
    "id": "Pacific/Enderbury",
    "description": "Pacific/Enderbury"
  },
  {
    "id": "Pacific/Fakaofo",
    "description": "Pacific/Fakaofo"
  },
  {
    "id": "Pacific/Fiji",
    "description": "Pacific/Fiji"
  },
  {
    "id": "Pacific/Funafuti",
    "description": "Pacific/Funafuti"
  },
  {
    "id": "Pacific/Galapagos",
    "description": "Pacific/Galapagos"
  },
  {
    "id": "Pacific/Gambier",
    "description": "Pacific/Gambier"
  },
  {
    "id": "Pacific/Guadalcanal",
    "description": "Pacific/Guadalcanal"
  },
  {
    "id": "Pacific/Guam",
    "description": "Pacific/Guam"
  },
  {
    "id": "Pacific/Honolulu",
    "description": "Pacific/Honolulu"
  },
  {
    "id": "Pacific/Johnston",
    "description": "Pacific/Johnston"
  },
  {
    "id": "Pacific/Kiritimati",
    "description": "Pacific/Kiritimati"
  },
  {
    "id": "Pacific/Kosrae",
    "description": "Pacific/Kosrae"
  },
  {
    "id": "Pacific/Kwajalein",
    "description": "Pacific/Kwajalein"
  },
  {
    "id": "Pacific/Majuro",
    "description": "Pacific/Majuro"
  },
  {
    "id": "Pacific/Marquesas",
    "description": "Pacific/Marquesas"
  },
  {
    "id": "Pacific/Midway",
    "description": "Pacific/Midway"
  },
  {
    "id": "Pacific/Nauru",
    "description": "Pacific/Nauru"
  },
  {
    "id": "Pacific/Niue",
    "description": "Pacific/Niue"
  },
  {
    "id": "Pacific/Norfolk",
    "description": "Pacific/Norfolk"
  },
  {
    "id": "Pacific/Noumea",
    "description": "Pacific/Noumea"
  },
  {
    "id": "Pacific/Pago_Pago",
    "description": "Pacific/Pago Pago"
  },
  {
    "id": "Pacific/Palau",
    "description": "Pacific/Palau"
  },
  {
    "id": "Pacific/Pitcairn",
    "description": "Pacific/Pitcairn"
  },
  {
    "id": "Pacific/Pohnpei",
    "description": "Pacific/Pohnpei"
  },
  {
    "id": "Pacific/Ponape",
    "description": "Pacific/Ponape"
  },
  {
    "id": "Pacific/Port_Moresby",
    "description": "Pacific/Port Moresby"
  },
  {
    "id": "Pacific/Rarotonga",
    "description": "Pacific/Rarotonga"
  },
  {
    "id": "Pacific/Saipan",
    "description": "Pacific/Saipan"
  },
  {
    "id": "Pacific/Samoa",
    "description": "Pacific/Samoa"
  },
  {
    "id": "Pacific/Tahiti",
    "description": "Pacific/Tahiti"
  },
  {
    "id": "Pacific/Tarawa",
    "description": "Pacific/Tarawa"
  },
  {
    "id": "Pacific/Tongatapu",
    "description": "Pacific/Tongatapu"
  },
  {
    "id": "Pacific/Truk",
    "description": "Pacific/Truk"
  },
  {
    "id": "Pacific/Wake",
    "description": "Pacific/Wake"
  },
  {
    "id": "Pacific/Wallis",
    "description": "Pacific/Wallis"
  },
  {
    "id": "Pacific/Yap",
    "description": "Pacific/Yap"
  },
  {
    "id": "Poland",
    "description": "Poland"
  },
  {
    "id": "Portugal",
    "description": "Portugal"
  },
  {
    "id": "ROC",
    "description": "ROC"
  },
  {
    "id": "ROK",
    "description": "ROK"
  },
  {
    "id": "Singapore",
    "description": "Singapore"
  },
  {
    "id": "Turkey",
    "description": "Turkey"
  },
  {
    "id": "UCT",
    "description": "UCT"
  },
  {
    "id": "US/Alaska",
    "description": "US/Alaska"
  },
  {
    "id": "US/Aleutian",
    "description": "US/Aleutian"
  },
  {
    "id": "US/Arizona",
    "description": "US/Arizona"
  },
  {
    "id": "US/Central",
    "description": "US/Central"
  },
  {
    "id": "US/East-Indiana",
    "description": "US/East-Indiana"
  },
  {
    "id": "US/Eastern",
    "description": "US/Eastern"
  },
  {
    "id": "US/Hawaii",
    "description": "US/Hawaii"
  },
  {
    "id": "US/Indiana-Starke",
    "description": "US/Indiana-Starke"
  },
  {
    "id": "US/Michigan",
    "description": "US/Michigan"
  },
  {
    "id": "US/Mountain",
    "description": "US/Mountain"
  },
  {
    "id": "US/Pacific",
    "description": "US/Pacific"
  },
  {
    "id": "US/Samoa",
    "description": "US/Samoa"
  },
  {
    "id": "UTC",
    "description": "UTC"
  },
  {
    "id": "Universal",
    "description": "Universal"
  },
  {
    "id": "W-SU",
    "description": "W-SU"
  },
  {
    "id": "WET",
    "description": "WET"
  },
  {
    "id": "Zulu",
    "description": "Zulu"
  }
]